import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Menu,
  MenuItem,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// Using native Date methods instead of date-fns

const DashboardHeader = ({ user }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  // State for add menu
  const [addMenuAnchorEl, setAddMenuAnchorEl] = useState(null);

  // Handle add menu open
  const handleAddMenuOpen = (event) => {
    setAddMenuAnchorEl(event.currentTarget);
  };

  // Handle add menu close
  const handleAddMenuClose = () => {
    setAddMenuAnchorEl(null);
  };

  // Handle navigation to add prospect page
  const handleAddProspect = () => {
    handleAddMenuClose();
    navigate("/prospects/add");
  };

  // Handle navigation to add coach page
  const handleAddCoach = () => {
    handleAddMenuClose();
    navigate("/coaches");
  };

  // Get current date formatted
  const getCurrentDate = () => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return new Date().toLocaleDateString("en-US", options);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5, // Reduced from 3 to 1.5
        mb: 1.5, // Reduced from 3 to 1.5
        borderRadius: 2,
        background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        color: "white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", mt: isMobile ? 1 : 0 }} // Reduced margin from 2 to 1
        >
          <Button
            component={RouterLink}
            to="/prospects/import"
            variant="contained"
            startIcon={<UploadFileIcon />}
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.9)",
              color: theme.palette.primary.main,
              mr: 1.5, // Reduced from 2 to 1.5
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 1)",
              },
            }}
          >
            Import Prospects
          </Button>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            endIcon={<KeyboardArrowDownIcon />}
            onClick={handleAddMenuOpen}
            sx={{
              bgcolor: "white",
              color: theme.palette.primary.main,
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 0.9)",
              },
            }}
          >
            Add New
          </Button>
          <Menu
            anchorEl={addMenuAnchorEl}
            open={Boolean(addMenuAnchorEl)}
            onClose={handleAddMenuClose}
          >
            <MenuItem onClick={handleAddProspect}>Add Prospect</MenuItem>
            <MenuItem onClick={handleAddCoach}>Add Coach</MenuItem>
          </Menu>
        </Box>
      </Box>
    </Paper>
  );
};

export default DashboardHeader;
